/**
 * Browser device detection — general-purpose, not analytics-specific.
 * UA-based device typing plus screen orientation and touch capability reads.
 * All reads are guarded for non-browser (SSR / test) environments.
 */

export type DeviceType = 'mobile' | 'tablet' | 'desktop'

export const deviceType = (): DeviceType | null => {
  if (typeof navigator === 'undefined') return null
  const ua = navigator.userAgent
  if (/iPad|Tablet/i.test(ua)) return 'tablet'
  if (/Mobi|Android|iPhone/i.test(ua)) return 'mobile'
  return 'desktop'
}

export const orientation = (): 'portrait' | 'landscape' | null => {
  if (typeof screen === 'undefined' || screen.orientation == null) return null
  return screen.orientation.type?.startsWith('landscape') ? 'landscape' : 'portrait'
}

export const isTouch = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}
